import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 3
const slug = 'preventative-electrical-servicing-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Preventative Electrical Servicing Sydney | ${BUSINESS_NAME}`,
        description: "Routine inspections and maintenance to extend the life of your electrical systems and reduce costly breakdowns.",
        keywords: "preventative electrical servicing Sydney, electrical system maintenance, routine electrical inspections, commercial electrical servicing, residential electrical maintenance, electrical safety checks, reduce electrical breakdowns, extend electrical system life, licensed electricians Sydney, proactive electrical solutions",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Preventative Electrical Servicing',
    description: 'Routine inspections and maintenance to extend the life of your electrical systems and reduce costly breakdowns.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
